<stby-modal
    [size]="modal.size"
    [modalOpen]="modalOpen"
    [denyClose]="modal.denyClose"
    [class.has-header-image]="modal.headerImage"
    (modalOpenChange)="modalOpenChange($event)"
>
    @if (modal.headerImage || modal.title) {
        <stby-modal-title>
            @if (modal.headerImage) {
                <img class="modal-header-image" alt="" aria-hidden="true" [src]="modal.headerImage" />
            }
            @if (modal.title) {
                <h2>{{ modal.title | translate: modal.titleParams }}</h2>
            }
        </stby-modal-title>
    }

    @if (modal.contentItems?.length) {
        <stby-modal-content>
            @for (item of modal.contentItems; track $index) {
                <div [class]="item.ngClass">
                    @if (item.contentTranslationKey) {
                        <div class="paragraph-wrapper">
                            @for (
                                paragraph of item.contentTranslationKey
                                    | translate: item.contentParams
                                    | stbyParagraphize;
                                track paragraph
                            ) {
                                <div class="paragraph-item" [innerHTML]="paragraph"></div>
                            }
                        </div>
                    }
                    @if (item.contentHTML) {
                        <div class="paragraph-wrapper" [innerHTML]="item.contentHTML"></div>
                    }
                    @if (item.contentString) {
                        <div class="paragraph-wrapper" [innerHTML]="item.contentString"></div>
                    }
                    @if (item.contentTemplateRef) {
                        <ng-container *ngTemplateOutlet="item.contentTemplateRef; context: { item }"> </ng-container>
                    }
                    @if (item.contentComponent) {
                        <ng-container
                            *ngComponentOutlet="item.contentComponent; inputs: item.componentInputs"
                        ></ng-container>
                    }
                    @if (item.type) {
                        @switch (item.type) {
                            @case (modalInputTypeEnum.Checkbox) {
                                <stby-checkbox
                                    [class]="[item.class ? item.class : '', item.hidden ? 'hidden' : '']"
                                    [checked]="item.formControl.value"
                                    [disabled]="item.formControl.disabled"
                                    (checkedChange)="item.formControl.setValue($event)"
                                >
                                    {{ item.label | translate }}
                                </stby-checkbox>
                            }
                            @case (modalInputTypeEnum.Number) {
                                <mat-form-field class="full-width" [class.hidden]="item.hidden">
                                    <mat-label>{{ item.label | translate }}</mat-label>
                                    <input
                                        matInput
                                        type="number"
                                        [placeholder]="item.placeholder | translate"
                                        [formControl]="item.formControl"
                                    />
                                </mat-form-field>
                            }
                            @case (modalInputTypeEnum.Radio) {
                                <!-- To be implemented -->
                            }
                            @case (modalInputTypeEnum.Select) {
                                <mat-form-field class="full-width" [class.hidden]="item.hidden">
                                    @if (item.label) {
                                        <mat-label>
                                            {{ item.label | translate }}
                                        </mat-label>
                                    }
                                    <mat-select
                                        [formControl]="item.formControl"
                                        [placeholder]="item.placeholder | translate"
                                        (selectionChange)="item.callbackOnChange && item.callbackOnChange($event)"
                                    >
                                        @for (option of item.options; track option.value) {
                                            <mat-option [value]="option.value">
                                                @if (option.translation) {
                                                    {{ option.translation | translate }}
                                                } @else {
                                                    {{ option.value }}
                                                }
                                            </mat-option>
                                        }
                                    </mat-select>
                                </mat-form-field>
                            }
                            @case (modalInputTypeEnum.Text) {
                                <mat-form-field class="full-width" [class.hidden]="item.hidden">
                                    <mat-label>{{ item.label | translate }}</mat-label>
                                    <input
                                        matInput
                                        type="text"
                                        [placeholder]="item.placeholder | translate"
                                        [formControl]="item.formControl"
                                    />
                                    @for (error of item.errors | keyvalue; track $index) {
                                        @if (
                                            item.formControl.touched &&
                                            !item.formControl.valid &&
                                            item.formControl.hasError(error.key)
                                        ) {
                                            <mat-error>
                                                {{ item.errors[error.key] | translate }}
                                            </mat-error>
                                        }
                                    }
                                </mat-form-field>
                            }
                            @case (modalInputTypeEnum.Date) {
                                <mat-form-field class="full-width" [class.hidden]="item.hidden">
                                    <mat-label>{{ item.label | translate }}</mat-label>
                                    <input
                                        matInput
                                        autocomplete="off"
                                        [matDatepicker]="modalDatePicker"
                                        [placeholder]="item.placeholder | translate"
                                        [formControl]="item.formControl"
                                        [min]="item.min"
                                        [max]="item.max"
                                    />
                                    <mat-datepicker-toggle matIconSuffix [for]="modalDatePicker">
                                    </mat-datepicker-toggle>
                                    <mat-datepicker #modalDatePicker />
                                    @for (error of item.errors | keyvalue; track $index) {
                                        @if (
                                            item.formControl.touched &&
                                            !item.formControl.valid &&
                                            item.formControl.hasError(error.key)
                                        ) {
                                            <mat-error class="modal-mat-error">
                                                {{ item.errors[error.key] | translate }}
                                            </mat-error>
                                        }
                                    }
                                </mat-form-field>
                            }
                            @case (modalInputTypeEnum.Textarea) {
                                <mat-form-field class="full-width" [class.hidden]="item.hidden">
                                    <mat-label>{{ item.label | translate }}</mat-label>
                                    <textarea
                                        matInput
                                        [placeholder]="item.placeholder | translate"
                                        [formControl]="item.formControl"
                                        [hidden]="item.hidden"
                                        [stbyAutofocus]="item.autofocus"
                                    ></textarea>
                                    @for (error of item.errors | keyvalue; track $index) {
                                        @if (
                                            item.formControl.touched &&
                                            !item.formControl.valid &&
                                            item.formControl.hasError(error.key)
                                        ) {
                                            <mat-error>
                                                {{ item.errors[error.key] | translate }}
                                            </mat-error>
                                        }
                                    }
                                </mat-form-field>
                            }
                        }
                    }
                </div>
            }
        </stby-modal-content>
    }

    @if (modal.buttons && modal.buttons.length) {
        <stby-modal-cta>
            @for (button of modal.buttons; track $index) {
                <stby-button
                    [label]="button.label"
                    [type]="button.type ? button.type : 'primary'"
                    [disabled]="
                        button.disabled ||
                        button.saving ||
                        (button.relatedInput && !button.relatedInput.formControl.valid) ||
                        (button.customValidator && button.customValidator(null) !== null) ||
                        (button.relatedInputs?.length && hasInvalidRelatedInputs(button))
                    "
                    [loading]="button.saving"
                    [destructive]="button.destructive ? true : false"
                    (clicked)="button.callback()"
                />
            }
        </stby-modal-cta>
    }
</stby-modal>
